import { cn } from "@/shared/utils";
import { ComponentProps, useId } from "react";
import { Helptext } from "./helptext";
import { Label } from "./label";

function Textarea({ className, ...props }: ComponentProps<"textarea">) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                "placeholder:text-content-placeholder selection:bg-primary selection:text-primary-foreground border-input-default bg-input md:text-m file:text-s text-m flex w-full min-w-0 rounded-md border px-2.75 py-1.75 shadow-xs transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
                "focus-visible:outline-focus focus-visible:border-transparent focus-visible:outline-2",
                "aria-invalid:outline-error aria-invalid:border-transparent aria-invalid:outline-2",
                className
            )}
            {...props}
        />
    );
}

type TextareafieldProps = ComponentProps<"textarea"> & {
    label: string;
    value: string;
    onValueChange: (value: string) => void;
    optional?: boolean;
    helptext?: string;
};

function TextareaField({ label, value, onValueChange, optional = false, helptext, ...props }: TextareafieldProps) {
    const id = useId();
    return (
        <div className="grid gap-1">
            <Label htmlFor={id} optional={optional}>
                {label}
            </Label>
            <Textarea id={id} value={value} onChange={(e) => onValueChange(e.target.value)} {...props} />
            {helptext && <Helptext>{helptext}</Helptext>}
        </div>
    );
}

export { Textarea, TextareaField };
